<template>
<layout>  
  <page-header :title="title"></page-header>
  <div>
    <b-col md="12">
      <b-card
        class="mb-2"
      >
        <b-card-text>
          <form-wizard>
            <tab-content title="Editar Producto" :before-change="() => validate()">
              <b-row>
                <b-col md="6">
                  <b-form-group
                    label="Nombre"
                    invalid-feedback="Este campo es requerido"
                  >
                  <template v-if="loadingProduct">
                    <b-skeleton type="input"></b-skeleton>
                  </template>
                  <template v-else>
                    <b-form-input
                      v-model.trim="form.name"
                      :state="state($v.form.name)"
                      :disabled="loadingCreate"
                    >
                    </b-form-input>
                  </template>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Costo"
                    invalid-feedback="Este campo es requerido"
                  >
                    <template v-if="loadingProduct">
                      <b-skeleton type="input"></b-skeleton>
                    </template>
                    <template v-else>
                      <b-form-input
                        v-model.trim="form.cost"
                        :state="state($v.form.cost)"
                        type="number"
                        :disabled="loadingCreate"
                      >
                      </b-form-input>
                    </template>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Precio"
                    invalid-feedback="Este campo es requerido"
                  >
                    <template v-if="loadingProduct">
                      <b-skeleton type="input"></b-skeleton>
                    </template>
                    <template v-else>
                      <b-form-input
                        v-model.trim="form.price"
                        :state="state($v.form.price)"
                        type="number"
                        :disabled="loadingCreate"
                      >
                      </b-form-input>
                    </template>
                  </b-form-group>
                </b-col>
                <!-- <b-col md="6">
                  <b-form-group
                    label="Unidades"
                    invalid-feedback="Este campo es requerido"
                  >
                    <template v-if="loadingProduct">
                      <b-skeleton type="input"></b-skeleton>
                    </template>
                    <template v-else>
                      <b-form-input
                        v-model.trim="form.stock"
                        :state="state($v.form.stock)"
                        type="number"
                        :disabled="loadingCreate"
                      >
                      </b-form-input>
                    </template>
                  </b-form-group>
                </b-col> -->
                <b-col md="6">
                  <b-form-group
                    label="Imagen"
                    invalid-feedback="Este campo es requerido"
                  >
                    <template v-if="loadingProduct">
                      <b-skeleton type="input"></b-skeleton>
                    </template>
                    <template v-else>
                      <b-form-file
                        plain
                        class="form-control"
                        v-model="form.image"
                        accept="image/*"
                        :disabled="loadingCreate"
                      >
                      </b-form-file>
                    </template>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Categoria"
                    invalid-feedback="Este campo es requerido"
                  >
                  <template v-if="loadingProduct">
                    <b-skeleton type="input"></b-skeleton>
                  </template>
                  <template v-else>
                    <b-form-select
                      class="form-control"
                      v-model="form.category"
                      :state="state($v.form.category)"
                      :options="categories"
                      :disabled="loadingCreate"
                    >
                    </b-form-select>
                  </template>
                  </b-form-group>
                </b-col>
              </b-row>
            </tab-content>
            <tab-content title="Código de barras">
              <div class="text-center" id="bar-code">
                <barcode :value="sku" format="" width="1">
                </barcode>
              </div>
              <div class="text-center">
                <b-button @click="printBarCode()">Descargar el código de barras</b-button>
              </div>
            </tab-content>
            <template slot="footer" slot-scope="props">
              <div class=wizard-footer-left>
                <wizard-button  v-if="props.activeTabIndex > 1 && !props.isLastStep" :style="props.fillButtonStyle">Anterior</wizard-button>
              </div>
              <div class="wizard-footer-right">
                <wizard-button 
                  v-if="!props.isLastStep"
                  @click.native="props.nextTab()" 
                  class="wizard-footer-right" 
                  :style="props.fillButtonStyle"
                  :disabled="loadingProduct || loadingCreate"
                >
                  <template v-if="loadingCreate">
                    <b-spinner small type="grow"></b-spinner>
                    Cargando...
                  </template>
                  <template v-else>
                    Siguiente
                  </template>
                </wizard-button>
                <wizard-button v-else @click.native="onComplete()" class="wizard-footer-right finish-button" :style="props.fillButtonStyle">{{props.isLastStep ? 'Finalizar' : 'Siguiente'}}</wizard-button>
              </div>
            </template>
          </form-wizard>
        </b-card-text>
      </b-card>
    </b-col>
  </div>
</layout>
</template>
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { required, numeric, decimal } from 'vuelidate/lib/validators'
import { FormWizard, TabContent, WizardButton } from 'vue-form-wizard'
import { storeComputed } from '@/state/helpers'
import { UPDATE_PRODUCT, GET_PRODUCT } from '@/api/graphql/mutations/products'
import { ALL_CATEGORY } from '@/api/graphql/query/category'
import { toast } from '@/utils/alerts'
import { decode_bs64 } from '@/utils/general'
import VueBarCode from 'vue-barcode'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

export default {
  components:{
    Layout,
    PageHeader,
    FormWizard,
    TabContent,
    'barcode': VueBarCode,
    WizardButton
  },
  data(){
    return{
      title: 'Productos',
      form: {
        name: null,
        price: null,
        image: null,
        category: null,
        store: null,
        active: true,
        cost: null
      },
      id: null,
      sku: null,
      categories: [
        { value: null, text: 'Selecciona una opción de la lista' },
      ],
      loadingProduct: true,
      loadingCreate: false,
    }
  },
  validations:{
    form: {
      name: { required },
      price: {  },
      category: { required },
      cost: { required, decimal }
    }
  },
  computed: {
    ...storeComputed,
  },
  methods: {
    async validate(){
      this.$v.form.$touch()
      if(this.form.price === ""){
        this.form.price = null
      }
      const isValid = !this.$v.form.$invalid
      this.form.store = this.idCurrentStore
      if (isValid === true){
        const result = await this.updateProduct()
        return result
      }else{
        return false
      }
    },
    state(item){
      const { $dirty, $error } = item
      return $dirty ? !$error: null
    },
    onComplete(){
      this.$router.push({
        name: 'list-products'
      })
    },
    async updateProduct(){
      this.loadingCreate = true
      const idInt = decode_bs64( this.id ).split(':')[1]
      const data = {
        ...this.form,
        price: this.form.price.toString(),
        cost: this.form.cost.toString()
      }
      try {
        const response = await this.$apollo.mutate({
          mutation: UPDATE_PRODUCT,
          variables: {
            product: {
              ...data
            },
            id: idInt
          }
        })
        const { updateProduct } = response.data
        this.loadingCreate = false
        if (updateProduct !== null){
          this.sku = updateProduct.product.sku
          return true 
        }else{
          toast('error', 'No se pudo guardar el producto.')
          return false
        }
      } catch (error) {
        this.loadingCreate = false
        toast('error', 'No se pudo guardar el producto.')
      }
    },
    async getCategory(){
      try {
        const response = await this.$apollo.query({
          query: ALL_CATEGORY
        })
        const { allCategory } = response.data
        if (allCategory !== null){
          this.formatCategorySelect(allCategory)
        }else{
          toast('error', 'No se pudo recuperar las categorias.')
        }
      } catch (error) {
        toast('error', 'No se pudo recuperar las categorias.')
      }
    },
    async getProduct(){
        try {
            const response = await this.$apollo.query({
              query: GET_PRODUCT,
              variables: {
                sku: this.$route.params.sku
              }
            })
            const { getProduct } = response.data
            if (getProduct !== null){
              this.id = getProduct.id
              this.form = this.formatDataProduct(getProduct)
              this.loadingProduct = false
            }
            else{
              this.loadingProduct = false
              toast('error', 'No se logró recuperar la información del producto.')
            }
        } catch (error) {
            this.loadingProduct = false
            toast('error', 'No se logró recuperar la información del producto.')
        }
    },
    formatDataProduct(product){
      return {
        name: product.name,
        price: parseFloat(product.price),
        category: product.category.id,
        store: product.store.id,
        active: product.active,
        cost: parseFloat(product.cost)
      }
    },
    formatCategorySelect(data){
      for (let item of data){
        const temp = {
          value: item.id,
          text: item.name
        }
        this.categories.push(temp)
      }
    },
    printBarCode(){
      const barCode = document.getElementById('bar-code')
      const windowPrint = window.open()
      windowPrint.document.write( barCode.innerHTML )
      windowPrint.document.close()
      windowPrint.print()
      windowPrint.close()
    }
  },
  beforeMount(){
    this.getProduct()
    this.getCategory()
  }
}
</script>